export default __webpack_public_path__ + "static/media/Frame 1 (4).9129d5ac.png";